module.exports = __webpack_public_path__ + "static/media/social_facebook.84a0fbc9.svg";